import { ImConferenceMemberDto, ImConferenceModeEnum } from '@app/api/im/dtos';
import { WsOnlineStatusMessage } from '@app/core/ws/ws-online-status.service';

export namespace ImGroupStateActions {
  export class Load {
    public static readonly type = '[ImGroup] Load';
  }

  export class ReloadGroup {
    public static readonly type = '[ImGroup] Reload';

    constructor(public readonly groupId: string) {}
  }

  export class LoadGroupIfNotLoaded {
    public static readonly type = '[ImGroup] Load Group If Not Loaded';

    constructor(public readonly groupId: string) {}
  }

  export class DeleteGroup {
    public static readonly type = '[ImGroup] Delete Group';

    constructor(public readonly groupId: string) {}
  }

  export class ReloadGroupMember {
    public static readonly type = '[ImGroup] Reload Group Member';

    constructor(
      public readonly groupId: string,
      public readonly memberId: string,
    ) {}
  }

  export class DeleteGroupMember {
    public static readonly type = '[ImGroup] Delete Group Member';

    constructor(
      public readonly groupId: string,
      public readonly memberId: string,
      public readonly memberType: string,
    ) {}
  }

  export class LoadConference {
    public static readonly type = '[ImGroup] Load Conference';

    constructor(public readonly groupId: string) {}
  }

  export class DeleteConference {
    public static readonly type = '[ImGroup] Delete Conference';

    constructor(public readonly groupId: string) {}
  }

  export class UpdateConference {
    public static readonly type = '[ImGroup] Update Conference';

    constructor(
      public readonly groupId: string,
      public readonly mode: ImConferenceModeEnum,
    ) {}
  }

  export class ReloadConferenceMembers {
    public static readonly type = '[ImGroup] Reload Conference Member';

    constructor(public readonly groupId: string) {}
  }

  export class UpsertConferenceMember {
    public static readonly type = '[ImGroup] Add Conference Member';

    constructor(
      public readonly groupId: string,
      public readonly member: ImConferenceMemberDto,
    ) {}
  }

  export class DeleteConferenceMember {
    public static readonly type = '[ImGroup] Delete Conference Member';

    constructor(
      public readonly groupId: string,
      public readonly member: ImConferenceMemberDto,
    ) {}
  }

  export class HandleOnlineStatusChanged {
    public static readonly type = '[ImGroup] Handle Online Status Changed';

    constructor(public readonly message: WsOnlineStatusMessage) {}
  }
}
